<template>
  <router-view />
</template>

<script>
import store, { name } from '@/modules/visitRegistry/store';
import storeMixin, { unRegisterMixin } from 'utils/mixins/storeGenerator';

export default {
  name: 'VisitWrapper',
  mixins: [storeMixin, unRegisterMixin],
  created() {
    if (this.$store.state[name] == undefined) {
      this.$store.registerModule(name, store);
    }
  },
  destroyed() {
    //Reset State Method
    this.$store.dispatch(`${name}/reset`); //Reset state
  },
};
</script>
